import {StreamingData} from "./typesTradingWs";
import {decode, encode} from "@msgpack/msgpack";


export function safeSend(ws: WebSocket, data: StreamingData): void {
    ws.send(encode(data));
}


export function safeRecv(ws: WebSocket): Promise<StreamingData> {
    return new Promise((resolve, reject) => {
        const onMessage = (ev: MessageEvent) => {
            cleanup();
            try {
                if (!(ev.data instanceof ArrayBuffer)) {
                    throw new Error("Expected binary msgpack frame, got non-binary data");
                }
                resolve(decode(new Uint8Array(ev.data)) as StreamingData);
            } catch (e) {
                reject(e);
            }
        };
        const onError = () => {
            cleanup();
            reject(new Error("WebSocket error while awaiting message"));
        };
        const onClose = (ev: CloseEvent) => {
            cleanup();
            reject(new Error(`WebSocket closed before message received: ${ev.code} ${ev.reason}`));
        };
        const cleanup = () => {
            ws.removeEventListener("message", onMessage);
            ws.removeEventListener("error", onError);
            ws.removeEventListener("close", onClose);
        };
        ws.addEventListener("message", onMessage);
        ws.addEventListener("error", onError);
        ws.addEventListener("close", onClose);
    });
}

